export default __webpack_public_path__ + "static/media/out-side.6de0b677.svg";